export const DEFAULT_PROPS = {
  size: 'lg',
  variant: 'primary',
} as const;
